import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Course name rules:
 * - Required (handled elsewhere)
 * - Min length 2, Max length 100
 * - Allowed chars: alphabets, numbers, spaces, hyphen(-), period(.), ampersand(&)
 * - Trim leading/trailing spaces
 * - Do not allow only spaces
 */

export const courseNameAllowedCharsValidator = (): ValidatorFn => {
  // Allowed: A-Z a-z 0-9 space - . &
  const re = /^[A-Za-z0-9 .&-]+$/;
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;

    const str = String(value);
    if (!re.test(str)) {
      return { courseNameAllowedChars: true };
    }
    return null;
  };
};

export const courseNameTrimValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;

    const str = String(value);
    if (str.trim() !== str) {
      return { courseNameTrim: true };
    }
    return null;
  };
};

export const courseNameNoAllSpacesValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined) return null;

    const str = String(value);
    if (str.length > 0 && str.trim().length === 0) {
      return { courseNameNoAllSpaces: true };
    }
    return null;
  };
};

export const courseNameMinLengthValidator = (min: number): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;

    const trimmed = String(value).trim();
    if (trimmed.length > 0 && trimmed.length < min) {
      return { courseNameMinLength: { requiredLength: min, actualLength: trimmed.length } };
    }
    return null;
  };
};

